import { Box, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import React from "react";

interface PreviewPaneProps {
  html: string;
  label?: string;
}

const PreviewPane: React.FC<PreviewPaneProps> = ({ html, label }) => (
  <Box
    sx={{
      minHeight: 200,
      border: "1px solid #ccc",
      borderRadius: 1,
      p: 1,
      background: "#fafafa",
      position: "relative",
      overflow: "visible", // allow label to float outside
    }}
  >
    {label && (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          position: "absolute",
          top: -10,
          left: 11.5,
          px: 0.4,
          background: "#fafafa",
          zIndex: 2,
          fontSize: "0.85rem",
          pointerEvents: "none",
          lineHeight: 1,
        }}
      >
        {label}
      </Typography>
    )}
    <div
      className="custom-editor-content"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html),
      }}
    />
    <style>{`
      .custom-editor-content div, .custom-editor-content p {
        margin: 0;
        padding: 0;
      }
      .custom-editor-content {
        line-height: 1.4;
      }
    `}</style>
  </Box>
);

export default PreviewPane;
